module.exports = __webpack_public_path__ + "static/media/bytt-nn-9.7a3c995a.mp3";